import React from 'react';
import PropTypes from 'prop-types';

import { AddToCartButton } from 'javascripts/components/add_to_cart_button';
import { Loader } from 'javascripts/components/loader';
import { graphQLQueries } from 'javascripts/shared/graphql/queries';
import { useGraphQLClientData } from 'javascripts/hooks/use-graphql-client-data';

import styles from 'stylesheets/components/sticky_cta_footer.module';

export function StickyCtaFooter({ audiobookId, buttonLabel }) {
  const { loading, forceRefreshData, audiobook } = useGraphQLClientData(graphQLQueries.audiobookForAudiobookButtons, {
    id: audiobookId,
  });

  if (loading) {
    return <Loader />;
  }

  if (!audiobook) {
    return null;
  }

  return (
    <div className={styles.stickyCtaFooter} data-testid='sticky-cta-footer'>
      <div className={styles.content}>
        <div className={styles.addToCartButtonWrapper}>
          <AddToCartButton
            audiobook={audiobook}
            buttonStyle='stickyFooter'
            inCart={!_.isNil(audiobook.currentUserShoppingCartItem)}
            inWishlist={!_.isNil(audiobook.currentUserWishlistItem)}
            trackingCategory='Sticky footer'
            onClick={forceRefreshData}
            label={buttonLabel}
          />
        </div>
      </div>
    </div>
  );
}

StickyCtaFooter.propTypes = {
  audiobookId: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
};
